module.exports = __webpack_public_path__ + "static/media/question-list.c644f0dd.png";